<div class="heading {{ justify() }}">
  <div class="title">
    <div class="title-container" [style.gap.px]="titleGap()">
      @if (identifierColor(); as color) {
        <div class="identifier {{ color }}"></div>
      }

      <ng-content select="[leftHeading]"></ng-content>

      <h6>{{ heading() | translate }}</h6>

      <ng-content select="[rightHeading]"></ng-content>
    </div>

    @if (count() != null) {
      <span class="count f-body-m f-semibold">{{ count() }}</span>
    }
  </div>

  <div class="options">
    <ng-content select="[options]"></ng-content>
  </div>
</div>

<div class="content">
  <ng-content></ng-content>
</div>
